module.exports = __webpack_public_path__ + "static/media/15-farleg.9d9c9135.mp3";